import { createFeatureSelector, createSelector } from '@ngrx/store';
import { UIStyleConfigurationState, UIStyleConfigurationStateConst } from '../../../AppState';

export const getUIStyleConfigurationState = createFeatureSelector<UIStyleConfigurationState>(UIStyleConfigurationStateConst);

export const getUIStyleConfigurationFormInputStyleState = createSelector(
    getUIStyleConfigurationState,
    (state: UIStyleConfigurationState) => state.FormInputStyle
);
